export default "__VITE_ASSET__DksPVW4m__"